import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { getData, postData } from "../api/protectedApi";
import { ToastContainer, toast } from "react-toastify";
import GetOtpBtn from "../component/auth/GetOtpBtn";
import styles from "./css/Withdraw.module.css";

const Withdraw = () => {
  const [balance, setBalance] = useState(0);
  const [amount, setAmount] = useState("");
  const [address, setAddress] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpTimer, setOtpTimer] = useState(0);

  const getBalance = () => {
    postData("/user/wallet_sum", {})
      .then((res) => {
        setBalance(res.data?.walletBalance || 0);
      })
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    getBalance();
  }, []);

  const handleGetOtp = async () => {
    try {
      setOtpLoading(true);
      const response = await getData("/user/withrawOtp", {});
      if (response.data.success) {
        toast.success("OTP Sent Successfully!");
        setOtpTimer(120);
      } else {
        toast.error(response.data.message || "Failed to send OTP");
      }
    } catch (error) {
      console.error(error);
      toast.error("Error sending OTP");
    } finally {
      setOtpLoading(false);
    }
  };

  useEffect(() => {
    let timer;
    if (otpTimer > 0) {
      timer = setTimeout(() => setOtpTimer(otpTimer - 1), 1000);
    }
    return () => clearTimeout(timer);
  }, [otpTimer]);

  const handleWithdraw = async () => {
    if (!amount || !address || !otp) {
      toast.error("Please fill all fields");
      return;
    }

    const payload = {
      amount: amount,
      walletAddress: address,
      otp: otp,
    };

    try {
      setLoading(true);
      const response = await postData("/user/placeWithraw", payload);

      if (response.data.success) {
        toast.success("Withdraw Request Submitted Successfully");
        getBalance();
        setAmount("");
        setAddress("");
        setOtp("");
      } else {
        toast.error(response.data.message || "Withdraw Failed");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while processing the withdrawal.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.withdrawContainer}>
      <motion.div
        className={styles.withdrawCard}
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.65, ease: [0.16, 1, 0.3, 1] }}
      >
        <h3 className={styles.cardTitle}>Withdraw Crypto</h3>
        <p className={styles.cardSubtitle}>Request funds withdrawal directly to your wallet address.</p>

        <div className={styles.infoBanner}>
          <div>
            <p className={styles.infoText}>Min Withdrawal: <span className={styles.infoHighlight}>10 USDT</span></p>
            <p className={styles.infoText}>Available Balance: <span className={styles.infoHighlight}>${balance.toFixed(3)}</span></p>
          </div>
          <i className="fas fa-wallet text-success fs-4"></i>
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Withdraw Amount (USDT)</label>
          <input
            type="number"
            min="0"
            step="any"
            className={styles.customInput}
            placeholder="0.00"
            value={amount}
            onChange={(e) => {
              const value = e.target.value;
              if (value < 0) return;
              setAmount(value);
            }}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Destination Address</label>
          <input
            type="text"
            className={styles.customInput}
            placeholder="0x..."
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>OTP Code</label>
          <div className={styles.otpRow}>
            <input
              type="text"
              className={styles.customInput}
              placeholder="Enter 6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
            />
            <GetOtpBtn
              onClick={handleGetOtp}
              loading={otpLoading}
              timer={otpTimer}
              className={styles.btnOtp}
            />
          </div>
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel}>Token Name</label>
          <select className={styles.customSelect} disabled>
            <option>USDT (BEP-20)</option>
          </select>
        </div>

        <button
          type="button"
          className={styles.btnSubmit}
          onClick={handleWithdraw}
          disabled={loading}
        >
          {loading ? "Processing..." : "Submit Withdrawal"}
        </button>
      </motion.div>
    </div>
  );
};

export default Withdraw;
